import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';
import TimerIcon from '../icons/Timer';
import Timer from './Timer';

import styles from '../../../styles/partials/timer-pill.module.scss';

const propTypes = {
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
    label: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
    icon: PropTypes.string,
    started: PropTypes.bool,
    onEnded: PropTypes.func,
    timerClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    date: null,
    label: null,
    icon: <TimerIcon />,
    started: false,
    onEnded: null,
    timerClassName: null,
    className: null,
};

function TimerPill({ date, label, icon, started, onEnded, timerClassName, className }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.inner}>
                {label !== null ? (
                    <div className={styles.label}>{label !== null ? label : null}</div>
                ) : null}
                {icon !== null ? <div className={styles.label}>{icon}</div> : null}
                <Timer
                    date={date}
                    started={started}
                    onEnded={onEnded}
                    showDigitsOnEnded
                    className={classNames([
                        styles.timer,
                        { [timerClassName]: timerClassName !== null },
                    ])}
                />
            </div>
        </div>
    );
}

TimerPill.propTypes = propTypes;
TimerPill.defaultProps = defaultProps;

export default TimerPill;
